export const W3config = {
    STAKING_CONTRACT_ADDRESS: "0x60df580eDA8D00C84eB2Eab6D5D8151C79f32565",
    USDT_CONTRACT_ADDRESS : "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
    USDT_DECIMAL : 6,
    T8_CONTRACT_ADDRESS : "0xF649CF7aB5ebD6348F9814677fBB4ea9A2b83d38",
    T8_DECIMALS : 8,
    CHAIN_ID: 137, 
    NETWORK : "Polygon Mainnet",
    DEPOSIT_FEE: 5
}